import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedSubscriptionsIds } from '../../../../../../selectors/tools';
import { DTSubscriptionSearchView } from '../../DTSubscriptionSearchView';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';

const DTSelectSubscriptionNode = () => {
  const dispatch = useDispatch();
  const selectedSubscriptionsIds = useSelector(getSelectedSubscriptionsIds);

  const handleNextButtonClick = () => {
    dispatch(addEdgeToDecisionTreePath('subscription_selected'));
  };

  return (
    <DTSubscriptionSearchView
      onNextButtonClick={handleNextButtonClick}
      isNextButtonActive={!isEmpty(selectedSubscriptionsIds)}
      isShowMacroButton={true}
    />
  );
};

export default DTSelectSubscriptionNode;
